export const GET_BROKERTREE_SUCCESS = 'GET_BROKERTREE_SUCCESS';
export const ADD_BROKERTREE_SUCCESS = 'ADD_BROKERTREE_SUCCESS';
export const MOVE_BROKERTREE_SUCCESS = 'MOVE_BROKERTREE_SUCCESS';
export const DELETE_BROKERTREE_SUCCESS = 'DELETE_BROKERTREE_SUCCESS';
export const UPDATE_BROKER_TREE = 'UPDATE_BROKER_TREE';
export const RESTORE_BROKERTREE_SUCCESS = 'RESTORE_BROKERTREE_SUCCESS';

// Chain
export const NEW_BROKER_CHAIN_SUCCESS = 'NEW_BROKER_CHAIN_SUCCESS';
export const CREATE_BROKER_CHAIN_SUCCESS = 'CREATE_BROKER_CHAIN_SUCCESS';
export const EDIT_BROKER_CHAIN_SUCCESS = 'EDIT_BROKER_CHAIN_SUCCESS';
export const UPDATE_BROKER_CHAIN_SUCCESS = 'UPDATE_BROKER_CHAIN_SUCCESS';

// FirmGroup
export const NEW_BROKER_FIRMGROUP_SUCCESS = 'NEW_BROKER_FIRMGROUP_SUCCESS';
export const CREATE_BROKER_FIRMGROUP_SUCCESS = 'CREATE_BROKER_FIRMGROUP_SUCCESS';
export const EDIT_BROKER_FIRMGROUP_SUCCESS = 'EDIT_BROKER_FIRMGROUP_SUCCESS';
export const UPDATE_BROKER_FIRMGROUP_SUCCESS = 'UPDATE_BROKER_FIRMGROUP_SUCCESS';

// Firm
export const NEW_BROKER_FIRM_SUCCESS = 'NEW_BROKER_FIRM_SUCCESS';
export const CREATE_BROKER_FIRM_SUCCESS = 'CREATE_BROKER_FIRM_SUCCESS';
export const EDIT_BROKER_FIRM_SUCCESS = 'EDIT_BROKER_FIRM_SUCCESS';
export const UPDATE_BROKER_FIRM_SUCCESS = 'UPDATE_BROKER_FIRM_SUCCESS';

// Agent
export const NEW_BROKER_AGENT_SUCCESS = 'NEW_BROKER_AGENT_SUCCESS';
export const CREATE_BROKER_AGENT_SUCCESS = 'CREATE_BROKER_AGENT_SUCCESS';
export const EDIT_BROKER_AGENT_SUCCESS = 'EDIT_BROKER_AGENT_SUCCESS';
export const UPDATE_BROKER_AGENT_SUCCESS = 'UPDATE_BROKER_AGENT_SUCCESS';

// List

export const LIST_BROKER_AGENT_SUCCESS = 'LIST_BROKER_AGENT_SUCCESS';
export const CREATE_BROKER_LIST_AGENT_SUCCESS = 'CREATE_BROKER_LIST_AGENT_SUCCESS';
export const UPDATE_BROKER_LIST_AGENT_SUCCESS = 'UPDATE_BROKER_LIST_AGENT_SUCCESS';
export const DELETE_BROKER_LIST_AGENT_SUCCESS = 'DELETE_BROKER_LIST_AGENT_SUCCESS';
export const RESTORE_BROKER_LIST_AGENT_SUCCESS = 'RESTORE_BROKER_LIST_AGENT_SUCCESS';
